<template>
  <Transition
    name="expand-transition"
    @before-enter="onBeforeEnter"
    @enter="onEnter"
    @after-enter="onAfterEnter"
    @before-leave="onBeforeLeave"
    @leave="onLeave"
    @after-leave="onAfterLeave"
  >
    <slot />
  </Transition>
</template>

<script setup>
function onBeforeEnter(el) {
  requestAnimationFrame(() => {
    if (!el.style.height) {
      el.style.height = 0
    }
  })
}
function onEnter(el) {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      el.style.height = `${el.scrollHeight}px`
    })
  })
}
function onAfterEnter(el) {
  el.style.height = null
}
function onBeforeLeave(el) {
  requestAnimationFrame(() => {
    if (!el.style.height) {
      el.style.height = `${el.offsetHeight}px`
    }
  })
}
function onLeave(el) {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      el.style.height = 0
    })
  })
}
function onAfterLeave(el) {
  el.style.height = null
}
</script>

<style lang="postcss" scoped>
.expand-transition-enter-active,
.expand-transition-leave-active {
  @apply transition-size duration-500 overflow-hidden;
}
.expand-transition-enter-from,
.expand-transition-leave-to {
  @apply h-0;
}
</style>
